import React, { useState, useEffect, useRef } from "react";
import "react-dropdown/style.css";
import "./editRobotMoreSettings.scss";
import Modal from "../modal/modal";
import Dropdown from "react-dropdown";
import ApiHandler from "../api";

const apiHandler = new ApiHandler();

function EditRobotSettingsComponent({ robot, closeModal, onRobotUpdated }) {
  const [robotData, setRobotData] = useState(() => ({
    ...robot,
    moreSettings: { ...(robot?.moreSettings || {}) },
  }));

  // Move reducer state to component state
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (robot && robot._id !== robotData._id) {
      setRobotData((prevState) => ({
        ...robot,
        moreSettings: { ...(robot?.moreSettings || {}) },
      }));
    }
  }, [robot, robotData._id]);

  const onChange = (value, param) => {
    const { moreSettings } = robotData;
    moreSettings[param] = value;
    setRobotData({ ...robotData, moreSettings });
  };

  const onSubmit = async () => {
    try {
      setIsLoading(true);

      const params = { moreSettings: robotData.moreSettings };

      await apiHandler.setRobotSettings(robot._id, params);

      setIsLoading(false);

      if (onRobotUpdated) {
        onRobotUpdated(robotData);
      }
      closeModal();
    } catch (err) {
      setIsLoading(false);
      alert(err.message);
    }
  };

  const onDirectionSelected = (item) => {
    //console.log("item",item);
    setRobotData({ ...robotData, direction: item.value });
  };

  const getTitle = () => {
    return `Robot ${robot.robotName} Settings`;
  };

  const items = [
    {
      text: "Row Number",
      value: "rowNumber",
      type: "number",
    },
    {
      text: "Row Length [m]",
      value: "rowLength",
      type: "number",
    },
    {
      text: "Serial Number",
      value: "serialNumber",
      type: "number",
    },
    {
      text: "PCB Version",
      value: "pcbNumber",
      type: "text",
    },
    {
      text: "Software Version",
      value: "swVersion",
      type: "text",
    },
    {
      text: "Flippers",
      value: "flippers",
      type: "checkbox",
    },
    {
      text: "Wheel Extension",
      value: "wheelExtension",
      type: "checkbox",
    },
    {
      text: "4 X 4",
      value: "fourByFour",
      type: "checkbox",
    },
    {
      text: "Bridges",
      value: "bridges",
      type: "checkbox",
    },
    {
      text: "Integral Panel",
      value: "integralPanel",
      type: "checkbox",
    },
    {
      text: "OCM",
      value: "OCM",
      type: "checkbox",
    },
    {
      text: "Robot version",
      value: "robotVersion",
      type: "text",
    },
    {
      text: "Panel size",
      value: "numberOfPanels",
      type: "text",
    },

    {
      text: "Docking Station",
      value: "dockingStation",
      type: "dropdown",
      options: [
        { value: "yes", label: "Yes" },
        { value: "no", label: "No" },
        { value: "partial", label: "Partial" },
      ],
    },
    {
      text: "Battery Size(AH)",
      value: "batterySize",
      type: "dropdown",
      options: [
        { value: "9", label: "9" },
        { value: "12", label: "12" },
        { value: "18", label: "18" },
        { value: "24", label: "24" },
        { value: "30", label: "30" },
      ],
    },
    {
      text: "Free Text",
      value: "freeText",
      type: "text",
    },
  ];

  const getClass = (item) =>
    item.type === "checkbox" ? "input-line checkbox" : "input-line";

  return (
    <Modal title={getTitle()} onClose={closeModal}>
      {items.map((item) =>
        item.type === "checkbox" ? (
          <div key={item.value} className="input-line checkbox">
            <input
              checked={robotData.moreSettings[item.value]}
              placeholder=""
              type={item.type}
              onChange={(e) => onChange(e.target.checked, item.value)}
            />
            <div className="input-description">{item.text}</div>
          </div>
        ) : item.type === "dropdown" ? (
          <div key={item.value} className="input-line">
            <div className="input-description">{item.text}</div>
            <Dropdown
              options={item.options}
              onChange={(option) => onChange(option.value, item.value)}
              value={
                robotData.moreSettings[item.value] !== undefined
                  ? robotData.moreSettings[item.value] + ""
                  : ""
              }
              className="dropdown"
              controlClassName="control"
              placeholderClassName="placeholder"
            />
          </div>
        ) : (
          <div key={item.value} className="input-line">
            <div className="input-description">{item.text}</div>
            <input
              value={robotData.moreSettings[item.value]}
              placeholder=""
              type={item.type}
              onChange={(e) => onChange(e.target.value, item.value)}
            />
          </div>
        )
      )}

      <div className="buttons-wrapper">
        <div className="button cancel" onClick={closeModal}>
          CANCEL
        </div>
        <div
          className={`button ${isLoading ? "loading" : ""}`}
          onClick={onSubmit}
          disabled={isLoading}
        >
          {isLoading ? "SAVING..." : "SUBMIT"}
        </div>
      </div>
    </Modal>
  );
}

export default EditRobotSettingsComponent;
